export const breadcrumbTheme = {
  root: {
    padding: ".25em .5em;",
    background: "{slate.50}",
  },
  extend: {
    margin: {
      bottom: "5px",
    },
    icon: {
      margin: {
        right: ".25em",
      },
    },
  },
  css: ({ dt }: { dt: (token: string) => string }) => `
    .p-breadcrumb {
      margin-bottom: ${dt("breadcrumb.margin.bottom")};
    }
    .p-breadcrumb-item-icon {
      margin-right: ${dt("breadcrumb.icon.margin.right")};
    }
  `,
};
